export default "__VITE_ASSET__De030rSu__"